import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { RViewWithActionov1gis5vq13n as RViewWithAction } from '../RView.mjs';
import { FutureElement3o36ukl4wk2br as FutureElement } from '../RView.commonHtml.js.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KeyCodes_instancevfnkc2xsbiba as KeyCodes_instance } from '../../models/KeyCode.commonHtml.mjs';
import { vpropka48um9uweps as vprop } from './helpers.commonHtml.mjs';
import { KeyboardHints3coyq4x1rsbe3 as KeyboardHints } from '../../models/data.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function TextArea$content$lambda($this$vprop) {
  // Inline function 'com.lightningkite.kiteui.views.valueString' call
  var tmp = $this$vprop.zb3_1.ib7_1.value;
  var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function TextArea$content$lambda_0($this$vprop, it) {
  // Inline function 'com.lightningkite.kiteui.views.valueString' call
  $this$vprop.zb3_1.ib7_1.value = it;
  return Unit_instance;
}
var TextAreaClass;
function TextArea() {
  if (TextAreaClass === VOID) {
    class $ extends RViewWithAction() {
      constructor(context) {
        super(context);
        this.tb5_1.xb3_1 = 'div';
        this.tb5_1.hb4_1.v('textarea-container');
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new (FutureElement())();
        this_0.xb3_1 = 'textarea';
        this_0.hb4_1.v('editable');
        this_0.hb4_1.v('kui');
        // Inline function 'com.lightningkite.kiteui.views.resize' call
        this_0.bb4_1.fb7_1.resize = 'none';
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var tmp0_safe_receiver = this_0.vb3_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keydown', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.gax() && !it.shiftKey && !(this.kbg_1 == null)) {
              var tmp0_safe_receiver = this.kbg_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.xbe(this);
              }
              it.preventDefault();
              it.stopImmediatePropagation();
            }
            return Unit_instance;
          });
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp_1 = this_0.eb4_1['on' + 'keydown'];
          var old = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
          var tmp_2 = 'on' + 'keydown';
          this_0.eb4_1[tmp_2] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.gax() && !it.shiftKey && !(this.kbg_1 == null)) {
              var tmp0_safe_receiver_0 = this.kbg_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.xbe(this);
              }
              it.preventDefault();
              it.stopImmediatePropagation();
            }
            return Unit_instance;
          };
        }
        this.tb5_1.zbt(this_0);
        tmp.pcl_1 = this_0;
        var tmp_3 = this;
        var tmp_4 = TextArea$content$lambda;
        tmp_3.qcl_1 = vprop(this.pcl_1, 'input', tmp_4, TextArea$content$lambda_0);
        this.qcl_1.tah(() => {
          this.tb5_1.eb9('data-replicated-value', this.qcl_1.f2());
          return Unit_instance;
        });
        this.rcl_1 = new (KeyboardHints())();
        this.scl_1 = '';
      }
      tcl(value) {
        this.scl_1 = value;
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        this.pcl_1.zb3_1.ib7_1.placeholder = value;
      }
      cbs(value) {
        var tmp0 = this.pcl_1.zb3_1;
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var value_0 = !value;
        tmp0.ib7_1.disabled = value_0;
      }
      dbs() {
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var tmp = this.pcl_1.zb3_1.ib7_1.disabled;
        var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null;
        return !(tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs);
      }
    }
    initMetadataForClass($, 'TextArea');
    TextAreaClass = $;
  }
  return TextAreaClass;
}
//region block: exports
export {
  TextArea as TextArea6va0jt1dj0tc,
};
//endregion

//# sourceMappingURL=TextArea.commonHtml.mjs.map
